import { get, post } from "helpers/api_helper"
import * as url from "helpers/url_helper"
import { call, put, takeEvery } from "redux-saga/effects"
import {
  fetchOnboardingSettingsFailed,
  fetchOnboardingSettingsSuccess,
  hideLoadingIndicator,
  saveOnboardingSettingsFailed,
  saveOnboardingSettingsSuccess,
  showLoadingIndicator,
  fetchOnboardingSettings as fetchOnboardingSettingsAction,
  showConfirmation,
} from "./actions"
import {
  FETCH_ONBOARDING_SETTINGS,
  SAVE_ONBOARDING_SETTINGS,
} from "./actionTypes"
import { getFormDataFromJSON } from "utils"

function* fetchOnboardingSettings() {
  try {
    yield put(showLoadingIndicator())
    const response = yield get(url.GET_ONBOARDING_SETTINGS)
    yield put(fetchOnboardingSettingsSuccess(response))
    yield put(hideLoadingIndicator())
  } catch (error) {
    yield put(fetchOnboardingSettingsFailed(error))
    yield put(hideLoadingIndicator())
  }
}

const wait = ms => new Promise(resolve => setTimeout(resolve, ms))

function* saveOnboardingSettings({ payload }) {
  try {
    yield put(showLoadingIndicator())
    const response = yield post(
      url.POST_ONBOARDING_SETTINGS,
      getFormDataFromJSON(payload)
    )
    yield put(saveOnboardingSettingsSuccess())
    yield put(showConfirmation())
    yield call(wait, 500)
    yield put(fetchOnboardingSettingsAction())
  } catch (error) {
    yield put(saveOnboardingSettingsFailed(error))
    yield put(hideLoadingIndicator())
  }
}

function* onboardingFlowSaga() {
  yield takeEvery(FETCH_ONBOARDING_SETTINGS, fetchOnboardingSettings)
  yield takeEvery(SAVE_ONBOARDING_SETTINGS, saveOnboardingSettings)
}

export default onboardingFlowSaga
